export default {"src":"/_next/static/media/welcome.6fb8ce22.svg","height":440,"width":418,"blurWidth":0,"blurHeight":0};